import { render, staticRenderFns } from "./fggl.vue?vue&type=template&id=6a5af495&scoped=true&"
import script from "./fggl.vue?vue&type=script&lang=js&"
export * from "./fggl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5af495",
  null
  
)

export default component.exports